import { TExpandedCard } from "@/app/types/partnerPageTypes";
import Image from "next/image";
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader";

const ExpandedCard = ({ isMore, data, cardAction, optimizedImage }: TExpandedCard) => {
    return (
        <div className={`expanded-card ${isMore && "open"}
            `}>
            <div className="relative img_container h-[3rem] w-[3rem] lg:h-[4.5rem] lg:w-[4.5rem]  mb-8 lg:mb-10">
                {optimizedImage ? (
                    <ImageWithLoader
                        src={data.imgSrc}
                        alt="partner"
                        sizeVariant="thumbnail"
                        contain
                        quality={75}
                    />
                ) : (
                    <Image src={data.imgSrc} alt="partner" fill className="object-contain" />
                )}
            </div>
            <h2 className="text-bodyL mb-4">{data.title}</h2>
            <p className={`text-bodyM font-national text-oBlack-60 
    `}>{data.description}</p>
            <p onClick={cardAction} className="uppercase text-labelS cursor-pointer underline font-minerva-bold mt-[1rem]">
                {isMore ? "Read Less" : "Read More"}
            </p>
        </div>
    );
}

export default ExpandedCard;